export default __webpack_public_path__ + "../staticImages/android-chrome-512x512.png";